import Quill from 'quill'

const Embed = Quill.import('blots/embed')

class PhotoShortcodeBlot extends Embed {
  static create(value = {}) {
    const node = super.create()
    const shortcode = value.shortcode || ''

    node.setAttribute('data-shortcode', shortcode)
    node.setAttribute('contenteditable', 'false')
    node.classList.add('ql-photo-shortcode-preview')

    if (value.kind === 'photo' && value.previewUrl) {
      const img = document.createElement('img')
      img.src = value.previewUrl
      img.alt = value.label || shortcode
      node.appendChild(img)
    } else {
      const label = document.createElement('span')
      label.className = 'ql-photo-shortcode-preview__label'
      label.textContent = value.label || shortcode
      node.appendChild(label)
    }

    return node
  }

  static value(node) {
    return {
      shortcode: node.getAttribute('data-shortcode') || '',
      kind: node.querySelector('img') ? 'photo' : 'photos',
      previewUrl: node.querySelector('img')?.getAttribute('src') || '',
      label: node.querySelector('.ql-photo-shortcode-preview__label')?.textContent || '',
    }
  }
}

PhotoShortcodeBlot.blotName = 'photo-shortcode'
PhotoShortcodeBlot.tagName = 'span'
PhotoShortcodeBlot.className = 'ql-photo-shortcode-preview'

export default PhotoShortcodeBlot
